module.exports = __webpack_public_path__ + "files/14622bbf40c830f2568365af0b4d24a3.png";